var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1vw",
    height: ".8vw",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63049 2.23422L5.43437 5.33325L7.50039 11.7658M7.50039 11.7658L9.62078 5.27888L8.47903 2.23422M7.50039 11.7658L1.90039 5.38762M7.50039 11.7658L13.1004 5.38762M1.90039 5.38762L4.29262 2.23422H10.7625L13.1004 5.38762M1.90039 5.38762H13.1004",
    stroke: "#40D2FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.e3b462d9c60d011fd111f1254e1c0073.svg";
export { ForwardRef as ReactComponent };